import {
  Component,
  Input,
  Output,
  EventEmitter,
  ChangeDetectionStrategy,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatRippleModule } from '@angular/material/core';
import { TranslateModule } from '@ngx-translate/core';
import { IconComponent } from '../icon';
import { IconName } from '@sc/data-access-assets';

@Component({
  selector: 'sc-nps-item',
  standalone: true,
  imports: [
    CommonModule,
    MatButtonModule,
    MatRippleModule,
    IconComponent,
    TranslateModule,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <div [id]="'score-' + score">
      <button
        (click)="onScoreClick()"
        [attr.aria-labelledby]="'nps-label-' + score"
      >
        <sc-icon [name]="getIconName()" class="icon"></sc-icon>
      </button>
      <p class="nps-label" [id]="'nps-label-' + score">
        {{ 'NpsDialog.scoreLabels.' + score | translate }}
      </p>
    </div>
  `,
  styleUrls: ['./nps-item.component.scss'],
})
export class NpsItemComponent {
  @Input() score!: number;
  @Output() scoreSelected = new EventEmitter<number>();

  private readonly iconMapping: { [key: number]: IconName } = {
    1: 'angry',
    2: 'frown',
    3: 'meh',
    4: 'smile',
    5: 'laugh',
  };

  getIconName(): IconName {
    return this.iconMapping[this.score] || 'meh';
  }

  onScoreClick(): void {
    this.scoreSelected.emit(this.score);
  }
}
